/* eslint-disable max-len */
// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const COLOR_SETS = {
  blue: {
    one: '#93C7EF',
    two: '#5A8BB0',
    three: '#CCE9F9',
    four: '#3C5D76',
    five: '#1E2E3B',
  },
};

export default class RobotIcon extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf(['blue']),
  }
  static defaultProps = {
    color: 'blue',
  }
  
  render() {
    const { className, color } = this.props;
    
    const colors = (COLOR_SETS[color] || {});
    
    return (
      <svg
        className={ className }
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        height={ '100%' }
        style={{ enableBackground: 'new 0 0 512 512' }}>
        <path
          fill={ colors.one }
          d="M302.545,69.818c0-25.707-20.84-46.545-46.545-46.545s-46.545,20.838-46.545,46.545
            c0,17.225,9.365,32.254,23.273,40.304v83.818h46.545v-83.818C293.181,102.073,302.545,87.043,302.545,69.818z" />
        <path
          fill={ colors.two }
          d="M256,23.273v170.667h23.273v-83.818c13.908-8.049,23.273-23.077,23.273-40.304
            C302.545,44.111,281.705,23.273,256,23.273z" />
        <rect
          y="240.485"
          fill={ colors.one }
          width="248.242"
          height="124.121" />
        <rect
          x="263.758" y="240.485"
          fill={ colors.two }
          width="248.242"
          height="124.121" />
        <rect
          x="186.182" y="364.606"
          fill={ colors.one }
          width="139.636"
          height="124.121" />
        <rect
          x="256" y="364.606"
          fill={ colors.two }
          width="69.818"
          height="124.121" />
        <rect
          x="46.545" y="162.909"
          fill={ colors.three }
          width="418.909"
          height="279.273" />
        <rect
          x="256" y="162.909"
          fill={ colors.one }
          width="209.455"
          height="279.273" />
        <path
          fill={ colors.four }
          d="M193.939,271.515c0,17.138-13.894,31.03-31.03,31.03l0,0c-17.136,0-31.03-13.892-31.03-31.03l0,0
            c0-17.138,13.894-31.03,31.03-31.03l0,0C180.046,240.485,193.939,254.377,193.939,271.515L193.939,271.515z" />
        <path
          fill={ colors.five }
          d="M380.121,271.515c0,17.138-13.894,31.03-31.03,31.03l0,0c-17.137,0-31.03-13.892-31.03-31.03l0,0
            c0-17.138,13.894-31.03,31.03-31.03l0,0C366.227,240.485,380.121,254.377,380.121,271.515L380.121,271.515z" />
        <path
          fill={ colors.four }
          d="M186.182,349.091c0,38.558,31.258,69.818,69.818,69.818l0,0c38.558,0,69.818-31.26,69.818-69.818
            H186.182z" />
        <path
          fill={ colors.five }
          d="M256,349.091c0,38.558,0,46.545,0,69.818l0,0c38.558,0,69.818-31.26,69.818-69.818H256z" />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RobotIcon/index.jsx